<template>
  <PlatformMxPlus
    ref="platform"
    :bridge="bridge"
    :localStoragePrefix="localStoragePrefix"
    :buttons="buttons"
    :outputs="outputs"
    :uarts="uarts"
    :leds="leds"
    :languages="languages"
    :vbusSpecifications="vbusSpecifications"
    displayType="NT7538"
    @initialized="platformInitialized"
  ></PlatformMxPlus>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformMxPlus from '@/device-platforms/PlatformMxPlus.vue';

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformMxPlus,
  },

  data: () => ({
    label: 'Citrin SLR XT 1.00',
    wasmUrl:'/100000003_Citrin_SLR_XT_1.00-P20plus-DW-MC.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S1', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 52.3, name: 'S2', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 62.3, name: 'S3', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S4', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S5', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S6', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S7', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S8', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S9', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S10', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S11', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S12', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S13', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S14', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S15', },
      { conversion: 'digitalState', value: null, initialValue: 0, name: 'S16', },
      { conversion: 'digitalState', value: null, initialValue: 0, name: 'S17', },
      { conversion: 'digitalState', value: null, initialValue: 0, name: 'S18', },
      { conversion: 'digitalState', value: null, initialValue: 0, name: 'S19', },
      { conversion: 'voltageGaTemperature', value: null, initialValue: 12.3, name: 'S21', },
      { conversion: 'voltageRpsPressure', value: null, initialValue: 2.3, name: 'S21', },
      { conversion: 'voltageRhTemperature', value: null, initialValue: 12.3, name: 'S22', },
      { conversion: 'voltageRhHumidity', value: null, initialValue: 12.3, name: 'S22', },
      { ref: 'S23Temperature', conversion: 'rawTemperature', value: null, initialValue: 12.3, name: 'S23', kind: 'dds', uartIndex: 2, },
      { ref: 'S23Pressure', conversion: 'rawPressure', value: null, initialValue: 2.3, name: 'S23', kind: 'dds', uartIndex: 2, },
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null },
      { name: 'R2', conversion: 'dutycyclePercent', value: null },
      { name: 'R3', conversion: 'dutycyclePercent', value: null },
      { name: 'R4', conversion: 'dutycyclePercent', value: null },
      { name: 'R5', conversion: 'dutycyclePercent', value: null },
      { name: 'R6', conversion: 'dutycyclePercent', value: null },
      { name: 'R7', conversion: 'dutycyclePercent', value: null },
      { name: 'R8', conversion: 'dutycyclePercent', value: null },
      { name: 'R9', conversion: 'dutycyclePercent', value: null },
      { name: 'R10', conversion: 'dutycyclePercent', value: null },
      { name: 'R11', conversion: 'dutycyclePercent', value: null },
      { name: 'R12', conversion: 'dutycyclePercent', value: null },
      { name: 'R13', conversion: 'dutycyclePercent', value: null },
      { name: 'R14', conversion: 'dutycyclePercent', value: null },
      { name: 'R15', conversion: 'dutycyclePercent', value: null },
      { name: 'A1', conversion: 'voltageVolts', value: null },
      { name: 'A2', conversion: 'voltageVolts', value: null },
      { name: 'A3', conversion: 'voltageVolts', value: null },
      { name: 'A4', conversion: 'voltageVolts', value: null },
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', },
      { name: 'UART1', kind: 'VBus', },
      { name: 'UART2', kind: 'VBus', },
      { name: 'UART3', kind: 'ModbusRtu', },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
    ],
  }),

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();

      // const vsfResponse = await fetch('/vbus_specification.vsf');
      // const vsfArrayBuffer = await vsfResponse.arrayBuffer();
      // const vsfBuffer = Buffer.from(vsfArrayBuffer);
      // const specificationFile = new SpecificationFile(vsfBuffer);
      // const specification = new Specification({ specificationFile });
      // this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
